import { z } from "zod";
export const hsmStatusEnum = z.enum([
    "APPROVED",
    "PENDING",
    "REJECTED",
    "PAUSED",
    "DISABLED",
    "UNKNOWN",
]);
export const hsmCategoryEnum = z.enum([
    "MARKETING",
    "UTILITY",
    "AUTHENTICATION",
    "OTHER",
]);
export const hsmTemplateSchema = z.object({
    id: z.number(),
    idcompany: z.number(),
    companyName: z.string().nullable(),
    idcanal: z.number().nullable(),
    providerCode: z.string(),
    templateExternalId: z.string(),
    templateName: z.string(),
    categoryCode: z.string(),
    language: z.string(),
    metaStatusCode: z.string(),
    metaRejectionReason: z.string().nullable(),
    lastSentAt: z.string().nullable(),
    lastTotal: z.number(),
    lastDelivered: z.number(),
    lastFailed: z.number(),
    lastFailureRate: z.number(),
    syncedAt: z.string(),
});
// ---------------------------------------------------------------------------
// Campañas programadas (envíos agendados de plantillas en el core de Gina).
// Fuente: socialmanager.SM_PLANTILLA (PROGRAMADO / FECHAPROGRAMADA /
// ESTADOPROGRAMADO / CANCELADO) + SM_PLANTILLA_DET (destinatarios).
// ---------------------------------------------------------------------------
export const scheduledCampaignStatusEnum = z.enum([
    "PENDING", // PROGRAMADO=1, ESTADOPROGRAMADO=1 — aún no la toma el poller
    "SENT", // ESTADOPROGRAMADO ∈ {-1, 2} — reclamada/entregada al sender
    "CANCELLED", // ESTADOPROGRAMADO=3 — cancelada ANTES del envío (0 mensajes)
    "SENT_CANCELLED", // ESTADOPROGRAMADO ∈ {-1,2} + CANCELADO=1 — cancelación
    //                   tardía: el sender ya la tenía; mensajes sí salieron
    "UNKNOWN",
]);
export const scheduledCampaignSchema = z.object({
    idplantilla: z.number(),
    nombre: z.string().nullable(),
    templateName: z.string().nullable(),
    idcompany: z.number().nullable(),
    companyName: z.string().nullable(),
    scheduledAt: z.string().nullable(), // ISO UTC
    status: scheduledCampaignStatusEnum,
    recipients: z.number(),
    authorName: z.string().nullable(),
    createdAt: z.string().nullable(),
});
export const cancelScheduledCampaignSchema = z.object({
    reason: z.string().min(3).max(500),
});
//# sourceMappingURL=template.js.map